import { NotifyHelper } from "../../../helpers/toast";
import { eEmailTemplateDefine } from "../../action-types/email/IEmailTemplateActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const emailTemplateActions = {
    ...generateActions(eEmailTemplateDefine, "EMAIL_TEMPLATE"),
    ...generateActionForKey(eEmailTemplateDefine, "EMAIL_TEMPLATE",
        "SAVE_ERROR", (m) => NotifyHelper.Error(m)),
    ...generateActionForKey(eEmailTemplateDefine, "EMAIL_TEMPLATE",
        "SAVE_SUCCESS", () => NotifyHelper.Success("Saved!")),
        ...generateActionForKey(eEmailTemplateDefine, "EMAIL_TEMPLATE",
        "DELETE_SUCESS", (m: any) => NotifyHelper.Success("Deleted")),
    ...generateActionForKey(eEmailTemplateDefine, "EMAIL_TEMPLATE",
        "DELETE_ERROR", (m: any) => NotifyHelper.Error(m))
}